export const SCREEN_SIZE_BORDER = 899;
export const SCREEN_SIZE_SM = 600
export const SCREEN_SIZE_MD = 900
export const SCREEN_SIZE_LESS_LG = 1000
export const SCREEN_SIZE_LG = 1200

export const MENU_OPEN = 'menuOpen'